import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {bookingsColumns} from './columns/_columns'
import {Booking} from '../core/_models'
import {BookingsListLoading} from '../components/loading/BookingsListLoading'
import {BookingsListPagination} from '../components/pagination/BookingsListPagination'
 import { KTCardBody } from '../../../../../_metronic/helpers'
//  import {KTBookingdBody} from '../../../../../../_metronic/helpers'

const BookingsTable = () => {
  const bookings = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => bookings, [bookings])
  const columns = useMemo(() => bookingsColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive' >
        <table
          id='kt_table_bookings'
          className='table align-middle table-row-dashed  fs-6 gy-5 dataTable booking-listing no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start bg-light-secondary fw-bolder fs-6 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Booking>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className=' fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Booking>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <BookingsListPagination />
      {isLoading && <BookingsListLoading />}
    </KTCardBody>
  )
}

export {BookingsTable}
